import {
	COMPANY_DOCUMENT_CATEGORY_KEY,
	resolveCompanyDocumentCategoryKey,
} from './companyDocumentCategories';
import { escapeHtml } from '../utils';

export const PROCEDURE_PURPOSE_TEXT = 'The purpose of this procedure is to provide clear, step-by-step instructions for one or more specific tasks. This ensures that a process is carried out consistently by all team members, regardless of who is responsible on a given day. By following procedures, we aim to maintain a safe working environment, safeguard company property, and promote accountability. This procedure helps prevent oversights, reduces operational risks, and ensures that all procedures are completed efficiently and in accordance with company standards.';

export const isProcedureCompanyDocument = document => (
	resolveCompanyDocumentCategoryKey(document?.categoryKey || document?.category?.key || document?.category?.name || document?.category) === COMPANY_DOCUMENT_CATEGORY_KEY.PROCEDURE
);

export const getProcedureResponsibleName = (document) => {
	const employee = document?.responsibleEmployee;
	if (!employee) {
		return '';
	}

	const displayName = [employee.preferredName || employee.firstName, employee.lastName]
		.filter(Boolean)
		.join(' ')
		.trim();

	return displayName || employee.personalEmail || '';
};

export const buildProcedureDocumentIntroHtml = (document) => {
	if (!isProcedureCompanyDocument(document)) {
		return '';
	}

	const responsibleName = getProcedureResponsibleName(document);
	const responsibleHtml = responsibleName
		? `<div style="margin-top: 12px;"><div style="font-size: 12px; font-weight: 700; letter-spacing: 0; text-transform: uppercase; color: #4b5563;">Responsible person</div><div style="margin-top: 3px;">${escapeHtml(String(responsibleName))}</div></div>`
		: '';

	return `<section style="border-left: 4px solid #2f855a; background: #f0fdf4; color: #1f2937; padding: 14px 16px; border-radius: 6px; margin: 0 0 18px;"><div style="font-weight: 700; margin-bottom: 6px;">Purpose</div><div style="line-height: 1.6;">${escapeHtml(PROCEDURE_PURPOSE_TEXT)}</div>${responsibleHtml}</section>`;
};

export const addProcedureDocumentIntroHtml = ({ document, contentHtml }) => {
	const introHtml = buildProcedureDocumentIntroHtml(document);
	const bodyHtml = String(contentHtml || '');

	if (!introHtml) {
		return bodyHtml;
	}

	return `${introHtml}<div class="people-procedure-body">${bodyHtml}</div>`;
};
